import * as React from 'react';
import './rvChart.css';

interface ChartLimitNoteProps {
    children: React.ReactNode;
}

// "The top 10 matter types are shown": one quiet pill with an info mark under the chart's legend, instead of a bare line of text. Display only; the
// chart decides when it shows, as before.
export const ChartLimitNote: React.FC<ChartLimitNoteProps> = ({ children }) => (
    <div className="rv-chart-limit-note">
        <span>
            <i aria-hidden={true}>i</i>
            {children}
        </span>
    </div>
);
